// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { PageInfoFragment } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import { gql } from '@apollo/client';
import { PageInfoFragmentDoc } from '../../../../graphql/fragments/pageInfo.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LiabilitiesTable_LiabilityFragment = { __typename?: 'Liability', id: string, displayName: string, currentAmount?: CurrencyUSD | null, notes?: string | null, paymentFrequency?: Types.LiabilityPaymentFrequency | null, recurringPaymentAmount?: CurrencyUSD | null, paymentKind?: Types.LiabilityPaymentKind | null, interestRate?: Percent | null, termStart?: Time | null, termEnd?: Time | null, finalPaymentAmount?: CurrencyUSD | null, sourceEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, sourceClientOrganization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, sourceClientProfile?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, recipientEntity?: { __typename?: 'Entity', id: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null, integrationLiability?: { __typename?: 'IntegrationLiability', id: string } | null };

export type LiabilitiesTableQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.LiabilityWhereInput>;
  orderBy?: Types.InputMaybe<Array<Types.LiabilityOrder> | Types.LiabilityOrder>;
  first: Types.Scalars['Int']['input'];
  after?: Types.InputMaybe<Types.Scalars['Cursor']['input']>;
}>;


export type LiabilitiesTableQuery = { __typename?: 'Query', paginatedData: { __typename?: 'LiabilityConnection', totalCount: number, pageInfo: (
      { __typename?: 'PageInfo' }
      & PageInfoFragment
    ), edges?: Array<{ __typename?: 'LiabilityEdge', node?: (
        { __typename?: 'Liability' }
        & LiabilitiesTable_LiabilityFragment
      ) | null } | null> | null } };

export const Operations = {
  Query: {
    LiabilitiesTable: 'LiabilitiesTable' as const
  },
  Fragment: {
    LiabilitiesTable_Liability: 'LiabilitiesTable_Liability' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const LiabilitiesTable_LiabilityFragmentDoc = gql`
    fragment LiabilitiesTable_Liability on Liability {
  id
  displayName
  currentAmount
  notes
  paymentFrequency
  recurringPaymentAmount
  paymentKind
  interestRate
  termStart
  termEnd
  finalPaymentAmount
  sourceEntity {
    id
    subtype {
      id
      displayName
    }
  }
  sourceClientOrganization {
    id
    name
  }
  sourceClientProfile {
    id
    displayName
  }
  recipientEntity {
    id
    subtype {
      id
      displayName
    }
  }
  integrationLiability {
    id
  }
}
    `;
export const LiabilitiesTableDocument = gql`
    query LiabilitiesTable($where: LiabilityWhereInput, $orderBy: [LiabilityOrder!], $first: Int!, $after: Cursor) {
  paginatedData: liabilities(
    where: $where
    orderBy: $orderBy
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      ...PageInfo
    }
    edges {
      node {
        ...LiabilitiesTable_Liability
      }
    }
  }
}
    ${PageInfoFragmentDoc}
${LiabilitiesTable_LiabilityFragmentDoc}`;

/**
 * __useLiabilitiesTableQuery__
 *
 * To run a query within a React component, call `useLiabilitiesTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useLiabilitiesTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLiabilitiesTableQuery({
 *   variables: {
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLiabilitiesTableQuery(baseOptions: Apollo.QueryHookOptions<LiabilitiesTableQuery, LiabilitiesTableQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LiabilitiesTableQuery, LiabilitiesTableQueryVariables>(LiabilitiesTableDocument, withFetchPolicyContext(options));
      }
export function useLiabilitiesTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LiabilitiesTableQuery, LiabilitiesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LiabilitiesTableQuery, LiabilitiesTableQueryVariables>(LiabilitiesTableDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useLiabilitiesTableSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LiabilitiesTableQuery, LiabilitiesTableQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LiabilitiesTableQuery, LiabilitiesTableQueryVariables>(LiabilitiesTableDocument, withFetchPolicyContext(options));
        }
export type LiabilitiesTableQueryHookResult = ReturnType<typeof useLiabilitiesTableQuery>;
export type LiabilitiesTableLazyQueryHookResult = ReturnType<typeof useLiabilitiesTableLazyQuery>;
export type LiabilitiesTableSuspenseQueryHookResult = ReturnType<typeof useLiabilitiesTableSuspenseQuery>;
export type LiabilitiesTableQueryResult = Apollo.QueryResult<LiabilitiesTableQuery, LiabilitiesTableQueryVariables>;